import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MainApi } from "../../../../../services/mainApi.service";
import {
  AutoComplete,
  AutoCompleteMulti,
  FormContainer,
  FormInput,
  ISelectType,
  SwitchInput,
  Treturn,
  useFetch,
} from "@4uhub/lib4uhub";
import { listSchema, TListForm } from "./listSchema";
import ListService from "../../../../../services/list.service";
import { useCallback } from "react";
import { listCategoriesByProfileAccess, listClassificationsByProfileAccess } from "../../../../../services/listProfileAccess.service";

const listService = new ListService();

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);

const translationPath = "page.4uDlist.list.";

const List = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(listService.create);

  const { sendRequest: update, loading: uLoading } = useFetch(
    listService.updateItemById
  );
  const { sendRequest: get, loading: gLoading } = useFetch(
    listService.getItemById
  );

  const formData = (v: TListForm) => {
    return {
      ...v,
      integrationTypeId: v.integrationType.id,
      listCategoriesIds: v.listCategories.map((c) => c.id),
      listClassificationsIds: v.listClassifications.map((c) => c.id),
    };
  };

  const saveHandler = (v: TListForm) => save(formData(v));

  const updateHandler = (v: TListForm, id: string) =>
    update({ item: formData(v), id: id });

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TListForm>> => {
      const { data, success } = await get(id);
      if (data && success) {
        return {
          data,
          success: true,
        };
      }
      return {
        data,
        success,
      };
    },
    [get]
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TListForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "list")}
      schema={listSchema}
      subtitle={t(translationPath + "new")}
      subtitleWatchField={"name"}
      fields={() => (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <SwitchInput
              name="enable"
              label={t(translationPath + "enable") || "Enable"}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <AutoComplete
              params={{ Identifier: "UserIntegrationType" }}
              name="integrationType"
              label={
                t(translationPath + "integration_type") || "Integration Type"
              }
              getOptionLabel={(option) => option.name}
              fullWidth
              autoFocus
              clearIcon={false}
              size="small"
              request={genericService.list}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <FormInput
              name="name"
              label={t(translationPath + "name") || "Name"}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              name="description"
              label={t(translationPath + "description") || "Description"}
              fullWidth
              size="small"
              multiline
              minRows={4}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AutoCompleteMulti
              name="listCategories"
              label={
                t(translationPath + "list_categories") || "List Categories"
              }
              getOptionLabel={(option) => option.name}
              request={listCategoriesByProfileAccess}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <AutoCompleteMulti
              name="listClassifications"
              label={
                t(translationPath + "list_classifications") ||
                "List Classifications"
              }
              getOptionLabel={(option) => option.name}
              request={listClassificationsByProfileAccess}
              size="small"
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default List;
